(function() {

    'use strict';

    angular.module('Services')
        .factory('AsyncRecursion', function($q) {
            return function (arr) {
                if(arr.length === 0){
                    throw 'No array promise defined';
                }
                let successCalls = 0;
                let failedCalls = 0;
                function start() {
                    const defer = $q.defer();

                    doAsyncSeries(arr, defer).finally(()=>{
                        defer.resolve({
                            totalCalls: arr.length,
                            successCalls,
                            failedCalls
                        });
                    });

                    return defer.promise;
                }

                function doAsyncSeries(arr, defer) {
                    return arr.reduce(function (promise, criteria, index) {
                        return promise.then(function(data) {
                            defer.notify(data);
                            successCalls++;
                        }).catch(err=>{
                            failedCalls++;
                        }).finally(()=>{
                            if(index === arr.length - 1) {
                                return;
                            }
                            return arr[index + 1]();
                        });
                    }, arr[0]());
                }

                this.start = start;
            }
        });
})();



// WEBPACK FOOTER //
// ./js/services/custom/Recursion.js